<div class="row" style="margin-bottom: 12px;">
    <div class="col-md-12" style="text-align: center;">
        This page will refresh in <div class="time">{{minutes}}</div> Min <div class="time">{{seconds}}</div> Sec
    </div>
</div>